import React from 'react';

const Footer = () => {
  return (
    <div className="container-fluid text-center footer mono">
      {/* <h3>I am available for hire!</h3> */}
      <h3>Ready to Collaborate!</h3>
      <br />
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js